export const errorMessages = {
  authentication_required: 'this card needs additional...',
  issuer_not_available: 'we were unable to...',
  processing_error: 'we were unable to...',
  withdrawal_count_limit_exceeded: "you've exceeded...",
  currency_not_supported:
    'this card does not support the specified currency...',
  card_decline: 'the card was declined...',
  card_not_supported: 'this card does not support this type of purchase...',
  expired_card: 'this card has expired...',
  saved_credit_card_expired: 'this card has expired...',
  insufficient_funds: 'this card does not have sufficient...',
  invalid_account: 'this card, or...',
  invalid_expiry_month: 'this card, or...',
  invalid_expiry_year: 'the expiry date entered...',
  invalid_cvc: 'the cvc entered is...',
  incorrect_cvc: 'the cvc entered is...',
  invalid_number: 'the card number entered...',
  incorrect_number: 'the card number entered...',
  call_issuer: 'the card was declined...',
  do_not_honor: 'the card was declined...',
  do_not_try_again: 'the card was declined...',
  generic_decline: 'the card was declined...',
  no_action_taken: 'the card was declined...',
  revocation_of_all_authorizations: 'the card was declined...',
  revocation_of_authorization: 'the card was declined...',
  security_violation: 'the card was declined...',
  service_not_allowed: 'the card was declined...',
  stop_payment_order: 'the card was declined...',
  transaction_not_allowed: 'the card was declined...',
  try_again_later: 'the card was declined...',
  default_error: 'order.error.payment.error',
  lost_card: 'the card was declined...',
  stolen_card: 'the card was declined...',
} as const;
